export function stripHtml(value: string): string {
  if (!value) {
    return value;
  }

  return value.replace(/<\/?[\w\s]*>|<.+[\W]>/g, '');
}
